/**
 * Viewport function to get window height and width
 *
 */
function viewport() {
  let e = window;
  let a = 'inner';
  if (!('innerWidth' in window)) {
    a = 'client';
    e = document.documentElement || document.body;
  }
  return { width: e[a + 'Width'], height: e[a + 'Height'] };
}

function onWindowResize(c, t) {
  onresize = function () {
    clearTimeout(t);
    t = setTimeout(c, 140);
  };
  return c;
}

function windowReize() {
  // console.log('resize called::');
  window.R_VIEWPORT_SIZE = viewport();
}
windowReize();
onWindowResize(windowReize);

(function (history) {
  const pushState = history.pushState;
  history.pushState = function (state) {
    pushState.apply(history, arguments);

    if (typeof history.onpushstate === 'function') {
      history.onpushstate({ state });
    }
    // whatever else you want to do
    // maybe call onhashchange e.handler
  };
}(window.history));
